var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import produce from 'immer';
export var getInitialState = function () { return ({
    datasets: [],
    columns: [],
    column_loading: false,
    column_error: false,
    loading: false,
    error: false,
    is_save_changes_disabled: false,
}); };
function columnReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        var _a;
        switch (action.type) {
            case 'ADD_COLUMN_REQUEST':
                state.column_loading = true;
                state.column_error = false;
                break;
            case 'ADD_COLUMN_SUCCESS':
                state.column_loading = false;
                state.column_error = false;
                state.columns = action.addedColumn
                    ? __spreadArray(__spreadArray([], state.columns, true), [action.addedColumn], false) : state.columns;
                break;
            case 'ADD_COLUMN_FAILURE':
                state.column_loading = false;
                state.column_error = true;
                break;
            case 'UPDATE_COLUMN_REQUEST':
                state.column_loading = true;
                state.column_error = false;
                break;
            case 'UPDATE_COLUMN_SUCCESS':
                state.column_loading = false;
                state.column_error = false;
                state.columns = state.columns.map(function (col) {
                    var _a;
                    if (col.id === ((_a = action.column) === null || _a === void 0 ? void 0 : _a.id)) {
                        return action.column;
                    }
                    return col;
                });
                break;
            case 'UPDATE_ARCHIVE_SUCCESS':
                state.column_loading = false;
                state.column_error = false;
                state.columns = state.columns.map(function (col) {
                    var _a;
                    if (col.id === ((_a = action.addedColumn) === null || _a === void 0 ? void 0 : _a.id)) {
                        return action.addedColumn;
                    }
                    return col;
                });
                break;
            case 'UPDATE_COLUMN_FAILURE':
                state.column_loading = false;
                state.column_error = true;
                break;
            case 'DELETE_COLUMN_REQUEST':
                state.column_loading = true;
                state.column_error = false;
                break;
            case 'DELETE_COLUMN_SUCCESS':
                state.column_loading = false;
                state.column_error = false;
                state.columns = state.columns.filter(function (col) { return col.id !== action.columnId; });
                break;
            case 'DELETE_COLUMN_FAILURE':
                state.column_loading = false;
                state.column_error = true;
                break;
            case 'LIST_DATASETS_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'LIST_DATASETS_SUCCESS':
                state.datasets = action.datasets ? action.datasets : [];
                state.loading = false;
                state.error = false;
                break;
            case 'LIST_DATASETS_FAILURE':
                state.loading = false;
                break;
            case 'GET_DATASET_COLUMN_REQUEST':
                state.loading = true;
                state.error = false;
                state.columns = [];
                break;
            case 'GET_DATASET_COLUMN_SUCCESS':
                state.columns = ((_a = action.column) === null || _a === void 0 ? void 0 : _a.fields) || [];
                state.loading = false;
                state.error = false;
                break;
            case 'GET_DATASET_COLUMN_FAILURE':
                state.loading = false;
                break;
            case 'UPDATE_IS_SAVE_CHANGES_DISABLED_SUCCESS':
                state.is_save_changes_disabled = action.disabled;
                break;
            case 'UPDATE_COLUMN_ORDER_SUCCESS':
                var orderedColumns_1 = [];
                action.columnsIdArray.map(function (cia) {
                    var column = state.columns.find(function (c) { return c.id === cia; });
                    column && orderedColumns_1.push(column);
                });
                var unOrderedColumns = state.columns.filter(function (c) { return !action.columnsIdArray.find(function (cia) { return cia !== c.id; }); });
                state.columns = __spreadArray(__spreadArray([], orderedColumns_1, true), unOrderedColumns, true);
                break;
            default:
                break;
        }
    });
}
export default columnReducer;
